import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { CareerConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { CareerPlanService } from './api/careerPlan.service';
import { CdpActivityService } from './api/cdpActivity.service';
import { CdpGoalService } from './api/cdpGoal.service';
import { CdpPackageService } from './api/cdpPackage.service';
import { CdpPackageItemService } from './api/cdpPackageItem.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class CareerApiModule {
    public static forRoot(configurationFactory: () => CareerConfiguration): ModuleWithProviders<CareerApiModule> {
        return {
            ngModule: CareerApiModule,
            providers: [ { provide: CareerConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: CareerApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('CareerApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
